import { deserialize, object, optional, serializable } from 'serializr';

export class BacklogProjectModel {
  @serializable
  public id: number;
  @serializable
  public projectKey: string;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogProjectModel, input));
  }
}

export class BacklogIssueTypeModel {
  @serializable
  public id: number;
  @serializable
  public name: string;
  @serializable
  public color: string;
  @serializable
  public projectId: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogIssueTypeModel, input));
  }
}

export class BacklogPriorityModel {
  @serializable
  public id: number;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogPriorityModel, input));
  }
}

export class BacklogUserModel {
  @serializable
  public id: number;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogUserModel, input));
  }
}

export class BacklogStatusModel {
  @serializable
  public id: number;
  @serializable
  public name: string;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogStatusModel, input));
  }
}

export class BacklogIssueModel {
  @serializable
  public id: number;
  @serializable
  public issueKey: string;
  @serializable
  public summary: string;
  @serializable
  public description: string;
  @serializable(optional(object(BacklogPriorityModel)))
  public priority: BacklogPriorityModel;
  @serializable(optional(object(BacklogIssueTypeModel)))
  public issueType: BacklogIssueTypeModel;
  @serializable(optional(object(BacklogUserModel)))
  public createdUser: BacklogUserModel;
  @serializable(optional(object(BacklogStatusModel)))
  public status: BacklogStatusModel;
  @serializable
  public created: string;
  @serializable
  public updated: string;
  @serializable
  public projectId: number;

  deserialize(input: any): this {
    return Object.assign(this, deserialize(BacklogIssueModel, input));
  }
}
